import { EntityTypes } from "../../EntityTypes";
import { ILanguageResource } from "../../languages";
import { IHydraResource, ITimestampable } from "../../types";
import { UserRole } from "../../users";

export enum AnnouncementStatus {
    DRAFT = "draft",
    PUBLISHED = "published",
}

export type IAnnouncementTargetClassroom = Pick<IHydraResource, "@id" | "@type"> & {
    title: string;
};

export interface IAnnouncementResource extends IHydraResource, ITimestampable {
    "@type": EntityTypes.ANNOUNCEMENT;
    uuid: string;
    language: ILanguageResource;
    title: string;
    body: string;
    videoUrl?: string | null;
    appearanceDate: string;
    targetRoles: UserRole[];
    targetClassrooms?: IAnnouncementTargetClassroom[];
    status: AnnouncementStatus;
}

export function isAnnouncementResource(resource: IHydraResource): resource is IAnnouncementResource {
    return resource["@type"] === EntityTypes.ANNOUNCEMENT;
}
